import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import { Card, CardContent, IconButton, List, ListItem, ListItemText } from '@mui/material';
import React from 'react';
import { EMAIL_TAGS } from '../../constants';

export const EmailTemplateTags = (): JSX.Element => {
  return (
    <Card elevation={0} sx={{ border: '1px solid #ccc' }}>
      <CardContent>
        <List component="nav" disablePadding>
          {EMAIL_TAGS.map((tag, index) => (
            <ListItem key={index} divider>
              <ListItemText primary={tag} primaryTypographyProps={{ variant: 'h5' }} />
              <IconButton onClick={() => navigator.clipboard.writeText(`<${tag}>`)}>
                <FileCopyOutlinedIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};
